module.exports = __webpack_public_path__ + "img/rebuild_huang_mob2.eea5e262.jpg";